import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../../../services/api';

export function useProject() {
  const { projectId } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    async function fetchProject() {
      try {
        setLoading(true);
        setError(null);
        const res = await api.get(`/projects/${projectId}`);
        if (!active) return;
        setProject(res.data || null);
      } catch (e) {
        if (!active) return;
        setError(e);
      } finally {
        if (active) setLoading(false);
      }
    }
    if (projectId) fetchProject();
    return () => {
      active = false;
    };
  }, [projectId]);

  return { project, loading, error };
}
